import React, { useState, useEffect } from 'react';
import cookie from "react-cookies";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from 'react-router-dom';

const InActiveMsg = () => {
    const selectedGstnList = useSelector(state => state.userReduser?.selectedGstnList)
    const dispatch = useDispatch();
    const history = useHistory();
    const gstinChange = useSelector(state => state.GstAuthReducer.gstinChange);
    const [gstinDetails, setGstinDetails] = useState();

    const userDetailsData = useSelector(state => state.GstAuthReducer.userDetailsData);
    const gstinSessionStatus = useSelector(state => state.gstr2aReducer.gstinSessionStatus);

    useEffect(() => {

        if (cookie.load("SELECTED_GSTIN_DETAIL") !== undefined) {
            // let get_data = JSON.parse(JSON.stringify(cookie.load("SELECTED_GSTIN_LIST")));
            let get_data = selectedGstnList
            let obj = get_data.find(o => o.gstin === cookie.load("SELECTED_GSTIN_DETAIL").gstin);
            let index = get_data.indexOf(obj);
            setGstinDetails(get_data[index]);
        }
    }, [userDetailsData, gstinChange]);


    useEffect(() => {

        if (gstinSessionStatus === false) {
            let getObj = gstinDetails;
            getObj.is_session_active = "Inactive";

            setGstinDetails(getObj);

            // let get_data = JSON.parse(JSON.stringify(cookie.load("SELECTED_GSTIN_LIST")));
            let get_data = selectedGstnList
            let obj = get_data.find(o => o.gstin === cookie.load("SELECTED_GSTIN_DETAIL").gstin);
            let index = get_data.indexOf(obj);
            get_data[index].is_session_active = "Inactive";
            cookie.save('SELECTED_GSTIN_LIST', get_data, { path: '/' });
            dispatch({ type: "SELECTED_GSTIN_LIST_STORE", payload: get_data });

        }

    }, [gstinSessionStatus]);

    const handleRefreshAPI = () => {
        history.push('/authentication');

        dispatch({ type: "REFRESH_GSTIN_SESSION", payload: true })

    }

    return (
        <>

            {gstinDetails !== undefined && <>

                {gstinDetails.is_session_active != 'Active' ?
                    <div className="alert alert-danger rounded-0 alert-dismissible text-center mb-0 p-1">
                        {/* <button type="button" className="close" data-dismiss="alert">&times;</button> */}
                        <p className="font-size-12 status-font mb-0 text-dark normal-demo-text"><i className="fas fa-exclamation-circle"></i> Authentication Session is Inactive for <span className="bold-label">GSTIN:{gstinDetails.gstin}</span> - <span className="bold-label">{gstinDetails.trade_name}</span>.
                            {/* <button className="btn btn-link text-primary btn-sm shadow-none bold-label" onClick={handleRefreshAPI}>REFRESH API</button> */}
                            <button className="btn btn-link text-primary btn-sm shadow-none bold-label ml-2" onClick={handleRefreshAPI}><i className="fas fa-redo"></i> REFRESH API</button>

                        </p>
                    </div>


                    : null}

            </>}
        </>
    )
};

export default InActiveMsg;